import { render, staticRenderFns } from "./answerSubmitUserDetail.vue?vue&type=template&id=df1e4c6a&scoped=true"
import script from "./answerSubmitUserDetail.vue?vue&type=script&lang=js"
export * from "./answerSubmitUserDetail.vue?vue&type=script&lang=js"
import style0 from "./answerSubmitUserDetail.vue?vue&type=style&index=0&id=df1e4c6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e4c6a",
  null
  
)

export default component.exports